exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#pricePerformance {\n  height: 570px; }\n\n/* hide the compare box */\n\n.amcharts-compare-div {\n  display: none; }\n\n/* \n  hide all <br> tags after the dropdown,\n  if dataSetSelector position is set to top or bottom, \n  hide the select due to different markup\n*/\n\n.amcharts-data-set-select ~ br, .amcharts-data-set-select ~ select {\n  display: none; }\n\n/* add a margin-bottom to space out the dropdown from the from/to text boxes */\n\n.amcharts-data-set-select {\n  margin-bottom: 1em; }\n\n.prepareChartPrint {\n  width: 510px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/price-performance/price-performance.component.scss
// module id = ../../../../../src/app/securities-level/price-performance/price-performance.component.scss
// module chunks = main